import Axios, { AxiosRequestConfig } from "axios";

export interface AxiosRequestConfigWithSuppressedErrorNotifications
    extends AxiosRequestConfig {
    suppressErrorNotificationForTypes?: string[];
}

export const suppressErrorNotificationForTypes = (
    types: string[]
): AxiosRequestConfigWithSuppressedErrorNotifications => ({
    suppressErrorNotificationForTypes: types,
});

export const shouldSuppressErrorNotification = (error: unknown): boolean => {
    if (!Axios.isAxiosError(error)) return false;

    const errorType = error.response?.data?.type;
    const config = error.config as
        | AxiosRequestConfigWithSuppressedErrorNotifications
        | undefined;
    const suppressedErrorTypes =
        config?.suppressErrorNotificationForTypes ?? [];

    return (
        typeof errorType === "string" &&
        Array.isArray(suppressedErrorTypes) &&
        suppressedErrorTypes.includes(errorType)
    );
};
